/**
 * @file Validates that a link template value includes its required placeholders.
 */

type ValidationRule = {
  validator: (_: unknown, value?: string) => Promise<void>;
};

/**
 * Creates a validation rule that requires the value to include every given placeholder.
 */
const getPlaceholderValidationRule = (
  placeholders: string[],
): ValidationRule => ({
  /**
   * Rejects the value when it omits any of the required placeholders.
   */
  validator: async (_, value) => {
    const isEmpty = !value || value.trim() === "";

    if (isEmpty) {
      return;
    }

    const missingPlaceholders = placeholders.filter(
      (placeholder) => !value.includes(placeholder),
    );
    const hasMissingPlaceholders = missingPlaceholders.length > 0;

    if (hasMissingPlaceholders) {
      throw new Error(`Must include ${missingPlaceholders.join(", ")}`);
    }
  },
});

export default getPlaceholderValidationRule;
